import { Component, Input, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DestroyBase } from "../../../../../components/common/ng-destroy-base";
import { FileAttachmentService } from "../../../services/file-attachment.service";
import { DateUtil } from "../../../../../components/common/date-util/date-util";

/**
 * Infobar (sidebar) that displays and handles attachments
 */
@Component({
  selector: 'file-attachment-list',
  templateUrl: './file-attachment-list.component.html',
  styleUrls: ['./file-attachment-list.component.css']
})
export class FileAttachmentListComponent extends DestroyBase implements OnInit {

  /**
   * The data behaviour subjext.
   */
  private _data$ = new BehaviorSubject(null);

  /**
   * Input property data.
   */
  @Input() set data(value: any) {
    this._data$.next(value);
  }

  /**
   * Input property mode.
   */
  @Input() mode: any;

  /**
   * List of all attachments.
   */
  attachmentList: { valuationPortfolioFileAttachment: any, propertyFileAttachment: any } = { valuationPortfolioFileAttachment: null, propertyFileAttachment: null };

  /**
   * Selected portfolio.
   */
  portfolio: any;

  /**
   * Selected report.
   */
  report: any;

  /**
    * Constructor
    */
  constructor(private fileAttachmentService: FileAttachmentService) {
    super();
  }

  /**
   *OnInit
   * */
  ngOnInit(): void {
    this.subscriptions.add(this._data$.subscribe((data) => {
      this.attachmentList.propertyFileAttachment = [];
      this.attachmentList.valuationPortfolioFileAttachment = [];
      if (data) {
        this.loadAttachments(data);
      }
    }));
  }

  /**
   * Load attachments
   * */
  private loadAttachments(data: any) {
    if (this.mode === 'report') {
      this.getReportAttachments(data.PropertyId, data.ValuationProjectId);
    } else if (this.mode === 'valuationProject') {
      this.getValuationEventAttachments(data.Oid);
    }
  }

  /**
   * Converts attachments dates
   * */
  private formatDateCreated(attachmentList: any[]) {
    if (attachmentList) {
      for (const entry of attachmentList) {
        entry.created = DateUtil.getDate(entry.created);
      }
    }
  }

  /**
   * Load attachments for a property and associated portfolio
   * */
  private getReportAttachments(propertyId: number, valuationProjectId: number) {
    this.fileAttachmentService.getReportAttachments(propertyId, valuationProjectId).subscribe((data: any) => {
      if (data) {
        this.formatDateCreated(data.propertyFileAttachment);
        this.formatDateCreated(data.valuationPortfolioFileAttachment);

        this.attachmentList.propertyFileAttachment = data.propertyFileAttachment;
        this.attachmentList.valuationPortfolioFileAttachment = data.valuationPortfolioFileAttachment;
      }
    });
  }

  /**
   * Load valuation portfolio attachments
   * */
  private getValuationEventAttachments(valuationProjectId: number) {
    this.fileAttachmentService.getValuationEventAttachments(valuationProjectId).subscribe((data: any[]) => {
      if (data) {
        this.formatDateCreated(data);

        this.attachmentList.valuationPortfolioFileAttachment = data;
      }
    });
  }

  /**
   * Initiate attachment download
   * */
  openAttachment(file: any, mode: string) {
    if (mode === 'report') {
      this.fileAttachmentService.initiateDownloadReportAttachment(file.oid);
    }
    else if (mode === 'valuationProject') {
      this.fileAttachmentService.initiateDownloadValuationEventAttachment(file.oid);
    }
  }
}
